import React, { useMemo } from 'react';
import { Select as OriSelect } from 'antd';
import PropTypes from 'prop-types';

// import '@style/components/select.scss';
import '../styles/components/select.scss';

const Options = OriSelect.Option;

function Select(props) {
  const {
    size,
    options = [],
    style = {},
    className = '',
    defaultValue,
    value,
    dropdownStyle,
    dropdownClassName,
    ...restProps
  } = props;
  const { onSelect } = props;
  const optionComps = useMemo(
    () =>
      options.map((opt) => (
        <Options
          className={`dd-select-option-${size}`}
          key={`selection-${opt.value}`}
          value={opt.value}
          style={
            String(opt.value).toLowerCase().includes('other')
              ? { color: 'var(--activeColor)' }
              : {}
          }
        >
          {opt.name || opt.label || opt.value}
        </Options>
      )),
    [options],
  );

  return (
    <OriSelect
      {...restProps}
      defaultValue={defaultValue}
      value={value}
      onSelect={onSelect}
      defaultActiveFirstOption={false}
      dropdownClassName={`${dropdownClassName || ''} dd-select-dropdown`}
      className={`dd-select dd-select-${size} ${className}`}
      style={style}
      dropdownStyle={{ ...dropdownStyle, fontSize: '2rem !important' }}
    >
      {optionComps}
    </OriSelect>
  );
}
Select.defaultProps = {
  style: {},
  onSelect: null,
  className: '',
  size: 'md',
};

Select.propTypes = {
  style: PropTypes.object,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  onSelect: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

export default Select;
